export type Length =
  | ""
  | "Less than 6 months"
  | "6-12 months"
  | "1-2 years"
  | "2-5 years"
  | "5+ years"
  | "I'm pregnant"
  | "I'm postpartum"
  | "I'm pursuing fertility preservation";

export const pregnantOption = "I'm pregnant";
export const postpartumOption = "I'm postpartum";
export const pursuingPreservationOption = "I'm pursuing fertility preservation";
export const shouldSeeDueDatePage = (lengthOfTimeTtc: Length) => {
  return (
    lengthOfTimeTtc == pregnantOption || lengthOfTimeTtc == postpartumOption
  );
};
